import React from "react";
import { useSelector } from "react-redux";
import { JobViewGrid as SharedJobViewGrid } from "tap/components/JobViewGrid";
import { useJobsActions } from "tap/store/tapJobs/useJobs.js";

export const JobViewGrid = () => {
  const {
    isJobViewModalOpen,
    jobViewFilterForm,
    jobViewTasks,
    selectedJob,
    taskStatusOptions,
    pendingStatuses,
    jobViewItemsPerPage,
  } = useSelector((state) => state.tapJobs);

  const { updateJobs, updateJobsSearchForm } = useJobsActions();

  return (
    <SharedJobViewGrid
      isJobViewModalOpen={isJobViewModalOpen}
      jobViewFilterForm={jobViewFilterForm}
      jobTasks={jobViewTasks}
      selectedJob={selectedJob}
      taskStatusOptions={taskStatusOptions}
      pendingStatuses={pendingStatuses}
      updateStore={updateJobs}
      updateSearchForm={updateJobsSearchForm}
      isLicensingJob={false}
      columnDefsKey="jobViewTasks"
      itemsPerPage={jobViewItemsPerPage}
    />
  );
};
